export default {
  title: "Wallet Card Design",
  emptyState: {
    pageUnavailable: "Page not available yet",
    description:
      "To access this page, you need to purchase the 'Promo' or 'Pro+' tariff",
    buttonText: "To Tariffs",
  },
  tradingPoint: "Trading Point",
  actions: {
    resetDesign: "Restore Default Design",
    saveChanges: "Save Changes",
  },
  walletCardPreview: {
    clientName: "Client Name",
    balance: "Balance",
    discount: "Discount",
  },
  walletCardSettings: {
    colors: {
      title: "Wallet Card Colors",
      background: "Background Color",
      text: "Text Color",
    },
    logo: {
      title: "Establishment Logo",
      noLogo: "No Logo",
      hasLogo: "Has Logo",
      aspectRatio: "Logo aspect ratio — 1:1",
      fileRequirements: "PNG, JPG, JPEG — 1 file up to 5 MB",
    },
    stripe: {
      title: "Background Layer",
      noStripe: "No Background Layer",
      image: "Image",
      colorFill: "Color Fill",
      aspectRatio: "Aspect ratio — 3:1",
      fileRequirements: "PNG, JPG, JPEG — 1 file up to 5 MB",
      color: "Background Layer Color",
    },
  },
};
